import { Link } from 'react-router-dom';
import { EmptyState, Page, Section } from '@marcianus/design/components';
import { ROUTES } from '@/app/routes';

// 404 do produto — EmptyState padrão + caminho de volta (nunca beco sem saída).
export function Placeholder({ title }: { title: string; embedded?: boolean }) {
  return (
    <Page>
      <EmptyState icon="globe" title={title} subtitle="Este endereço não existe (ou ainda não). Volta ao mapa." />
      <Section style={{ display: 'flex', justifyContent: 'center' }}>
        <Link to={ROUTES.attendee.explore} className="btn btn-purple btn-sm">← Voltar aos eventos</Link>
      </Section>
    </Page>
  );
}
